'use client';

import ease from '@/constants/ease';
import "@/styles/libs/arrow-animation.css";
import { motion } from 'framer-motion';
import Image from 'next/image';
import Link from 'next/link';
import { FC, useState } from 'react';
export interface AiFeaturesCondenseProps {
  backgroundColor: string;
  blurImage: string;
  imageFirst: boolean;
  sectionColorText: string;
  featuresTitleTextColor: string;
  featuresTextColor: string;
  aiFeature: string;
  featuresTitle: React.ReactNode,
  activeFeatureBoxColor: string;
  features: {
    image: React.ReactNode,
    title: React.ReactNode,
    description: string;
  }[]
}

const AiFeaturesCondense: FC<AiFeaturesCondenseProps> = ({
  backgroundColor,
  blurImage,
  imageFirst,
  sectionColorText,
  featuresTitleTextColor,
  featuresTextColor,
  aiFeature,
  featuresTitle,
  activeFeatureBoxColor,
  features = [],
}) => {
  const [activeFeatureIndex, setFeatureIndex] = useState(0);

  return (
    <div className="bg-violet-800 text-white" style={{ backgroundImage: `url(/images/${blurImage})` }}>
      <div className="flex bg-center">
        <div className="mx-auto max-w-[1384px] overflow-hidden">
          <div style={{ backgroundImage: `url(/images/${blurImage})` }} className={`grid gap-2 md:gap-3 text-left ${backgroundColor} ${sectionColorText} bg-center bg-top bg-no-repeat`}>
            <div className="flex justify-left md:justify-center flex-wrap pb-[48px] md:pb-[120px] px-[16px] md:px-0 overflow-hidden">
              <div className={`flex w-full flex-wrap md:flex-nowrap justify-center items-start mt-0 md:mt-[112px] ${imageFirst ? "flex-row-reverse" : null}`}>
                <div className={`flex flex-wrap w-full overflow-hidden md:w-[40%] ${imageFirst ? "mr-0 ml-0 px-0 md:mr-[32px] md:ml-[50px]" : "mr-0 ml-0  md:ml-[32px] md:mr-[140px]"}`}>
                  <div className="flex w-full mb-[24px] mt-[50px] md:mt-0">
                    <div className="flex bg-violet-1000 rounded-[20px] md:ml-[32px] items-center">
                      <div className="flex" id="icon">
                        <span className="flex w-[32px] h-[32px] rounded-[40%] justify-center items-center mr-[8px] mt-[2px] mb-[2px] ml-[2px]">
                          <Image src="https://front.com/webassets/rebrand/ai-icon.svg" width={37} height={37} alt="ai icon" />
                        </span>
                      </div>
                      <div className="flex text-p2 text-white font-500 mr-[13px]" id="textHeader">
                        {aiFeature}
                      </div>
                    </div>
                  </div>
                  <div className={`${featuresTitleTextColor} text-h1 font-500 mb-[24px] md:ml-[32px] w-full`}>{featuresTitle}</div>
                  <div className="flex md:ml-[32px] mb-[24px]">
                    <div className="flex items-center hover-arrow-wrapper">
                      <div className="flex font-500 text-white text-p2 w-full">
                        <Link
                          className="font-500 text-white text-p2"
                          href="/product/ai"
                        > Learn more</Link>
                      </div>
                      <div className="flex ml-[8px] relative w-[16px] h-[16px] bg-[url(https://front.com/webassets/rebrand/arrow-right.png)] hover-arrow" />
                    </div>
                  </div>
                  <div className="flex md:hidden flex-wrap">
                    {features.map((feature, index) => (
                      <div key={`ai-feature-${index}`} className={`flex w-full flex-wrap cursor-pointer first:border-t border-b border-solid border-violet-600`} onClick={() => setFeatureIndex(index)}>
                        <div className={`flex w-full justify-between font-500 text-p1 pt-[24px] ${activeFeatureIndex === index ? "pb-0" : "py-[24px]"} ${featuresTitleTextColor}`}>
                          <div className="flex">
                            {feature.title}
                          </div>
                          <div className="flex">
                            {activeFeatureIndex === index
                              ?
                              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 28 28" fill="none">
                                <path d="M9.3335 14H18.6668" stroke="#A857F1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              </svg>
                              :
                              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 28 28" fill="none">
                                <path d="M14 9.33333V18.6667" stroke="#A857F1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M9.3335 14H18.6668" stroke="#A857F1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              </svg>
                            }
                          </div>

                        </div>
                        {activeFeatureIndex === index && (
                          <motion.div
                            className={`flex ${featuresTextColor} flex-wrap text-p2 pb-[32px] justify-center`}
                            initial={{ opacity: 0, y: 5 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{
                              duration: 400 / 1000,
                              ease: ease.appear,
                            }}
                          >
                            {feature.description}
                            <div className="flex mt-[16px]">
                              {feature.image}
                            </div>
                          </motion.div>
                        )}
                      </div>
                    ))}
                  </div>
                  <div className="hidden md:flex flex-wrap">
                    {features.map((feature, index) => (
                      <div key={`ai-feature-${index}`} className={`flex w-full flex-wrap cursor-pointer mt-[24px] ${activeFeatureIndex === index ? `${activeFeatureBoxColor} rounded-[20px]` : null}`} onClick={() => setFeatureIndex(index)}>
                        <div className={`flex ml-[16px] md:ml-[32px] font-500 text-p1 ${activeFeatureIndex !== index ? "pt-[8px]" : "pt-[24px]"} ${featuresTitleTextColor}`}>
                          {feature.title}
                        </div>
                        {activeFeatureIndex === index && (
                          <motion.div
                            className={`flex ${featuresTextColor} text-p2 pl-[32px] pr-[32px] pb-[32px] mt-[12px]`}
                            initial={{ opacity: 0, y: 5 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{
                              duration: 400 / 1000,
                              ease: ease.appear,
                            }}
                          >
                            {feature.description}
                          </motion.div>
                        )}
                      </div>
                    ))}
                  </div>
                  <div className="hidden flex-wrap">
                    {features.map((feature, index) => (
                      <div key={`ai-feature-${index}`} className={`flex w-full flex-wrap cursor-pointer mt-[24px] ${activeFeatureBoxColor} rounded-[16px]`}>
                        <div className="flex ml-[16px] md:ml-[32px] font-500 text-p1 pt-[24px]">
                          {feature.title}
                        </div>

                        <motion.div
                          className={`flex ${sectionColorText} text-p2 pl-[32px] pr-[32px] pb-[32px] mt-[24px]`}
                          initial={{ opacity: 0, y: 5 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{
                            duration: 400 / 1000,
                            ease: ease.appear,
                          }}
                        >
                          {feature.description}
                        </motion.div>

                      </div>
                    ))}
                  </div>
                </div>
                <div className={`hidden md:flex w-full md:w-[50%] justify-left mt-[18px] md:mt-0 ${imageFirst ? " ml-0 md:ml-[64px]" : "mr-0 md:mr-[64px]"}`}>
                  {features[activeFeatureIndex].image}
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AiFeaturesCondense;
